import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  minhas_vendas: number;
  vendas_parceiros: number;
  numero_vendas: number;
}

// tipagem do que o hook retorna
type ICertificadosReponse = IResponseData;

async function getDadosCertificados(): Promise<ICertificadosReponse> {
  const response = await backend.get<IResponseData>('/dados-certificados');
  return response.data;
}

export function useDadosCertificados() {
  return useQuery(['dados-certificados'], () => getDadosCertificados(), {
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
  });
}
